import ResumeReadyLanding from './NewLanding';

export default function Page() {
  return <ResumeReadyLanding />;
}
